var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-black flex-col relative w-full h-full flex items-center"},[_c('img',{ref:"start",staticClass:"video"}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }